import React from 'react';
import './term.css';
export default class ContactTwo extends React.Component {
	
    render(){
        return (
            <section className="terms-section">
                <div className="container">
                    <div className="terms-card">

                        <div className="terms-header">
                            <h2>Terms & Conditions</h2>
                            <p><strong>Effective Date:</strong> 3 March 2026</p>
                        </div>

                        <div className="terms-content">

                            <p className="intro">
                                Welcome to Biz Index Directory. By accessing or using our platform 
                                to discover, search, and connect with businesses, you agree to comply 
                                with these terms.
                            </p>

                            <div className="term-block">
                                <h4>1. Acceptance of Terms</h4>
                                <p>
                                    By using this platform, you agree to these Terms and Conditions. 
                                    If not, please do not use our services.
                                </p>
                            </div>

                            <div className="term-block">
                                <h4>2. Use of Website</h4>
                                <ul>
                                    <li>Discover top-rated businesses</li>
                                    <li>Search, compare, and connect</li>
                                    <li>Use only for lawful purposes</li>
                                </ul>
                            </div>

                            <div className="term-block">
                                <h4>3. User Accounts</h4>
                                <ul>
                                    <li>Account may be required</li>
                                    <li>Keep credentials secure</li>
                                    <li>Provide accurate information</li>
                                </ul>
                            </div>

                            <div className="term-block">
                                <h4>4. Listings and Content</h4>
                                <p>
                                    We strive for accuracy but do not guarantee completeness. 
                                    Always verify details with businesses.
                                </p>
                            </div>

                            <div className="term-block">
                                <h4>5. Intellectual Property</h4>
                                <p>
                                    All content belongs to Biz Index Directory. Unauthorized use is prohibited.
                                </p>
                            </div>

                            <div className="term-block">
                                <h4>6. Third-Party Links</h4>
                                <p>We are not responsible for third-party websites.</p>
                            </div>

                            <div className="term-block">
                                <h4>7. Limitation of Liability</h4>
                                <p>Services are provided “as is” without warranties.</p>
                            </div>

                            <div className="term-block">
                                <h4>8. Privacy and Data Protection</h4>
                                <p>Your data is handled according to our Privacy Policy.</p>
                            </div>

                            <div className="term-block">
                                <h4>9. Modifications</h4>
                                <p>We may update these terms at any time.</p>
                            </div>

                            <div className="term-block">
                                <h4>10. Governing Law</h4>
                                <p>Governed by applicable laws.</p>
                            </div>

                        </div>

                    </div>
                </div>
            </section>
        )
    }
}